import React from 'react';
import moment from 'moment';
import { useFormContext } from 'react-hook-form';
import { Box, Button, Stack, Typography } from '@mui/material';
import { SelectField, InputField } from 'components/form';
import { EquipmentCondition } from '@trnsact/trnsact-shared-types';

export const InventoryTableFilters = () => {
  const { control, setValue, reset } = useFormContext();

  const handleVinOrStockNumberChange = (value: string) => {
    setValue('filters', {
      vin: value,
      stockId: value,
      yearFrom: parseInt(value, 10) ? parseInt(value, 10) : undefined,
      yearTo: parseInt(value, 10) ? parseInt(value, 10) : undefined,
      make: [value],
      model: [value],
    });
  };

  return (
    <Stack>
      <Stack direction="row" justifyContent="space-between">
        <Typography variant="h6" component="span">
          Filters:
        </Typography>
      </Stack>

      <Box sx={{ display: 'grid', gridTemplateColumns: '2fr 1fr 1fr', gap: '1rem', alignItems: 'flex-start' }}>
        <InputField
          control={control}
          name="filters.vin"
          label="Vin, Stock Number, Year/Make/Model"
          extraAction={{ cb: handleVinOrStockNumberChange }}
        />
        {/* <SelectField
          size="medium"
          label="Condition"
          control={control}
          name="filters.condition"
          options={[
            { label: 'All', value: 'all' },
            ...Object.values(EquipmentCondition).map((condition) => ({
              label: condition,
              value: condition,
            })),
          ]}
        /> */}
      </Box>
    </Stack>
  );
};
